<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-2 col-md-12 col-2">
                    <h2>Executed Trades</h2>
                    </div>
                    <div class="col-lg-10 col-md-12 col-10 text-right bid">
                      <div class="input-group d-inline-flex justify-content-end">
                        <!-- <button  @click="openAddNewCusipModal()" type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSIP</button> -->
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                        <i @click="searchOffer()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchOffer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                     
                        <!-- <button style="margin-right: .5rem;" type="button" disabled class="btn btn-warning rounded"><i class="fas fa-print"></i> Print All</button> -->
                        <button @click="openAddOfferModal()" type="button" class="btn btn-success rounded"><i class="fas fa-plus"></i> Add Trade</button>

                         </div>
                        <!-- <button type="button" class="btn btn-danger rounded"><i class="far fa-minus-square"></i> Suspend All</button> -->
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                    <div class="col-md-6 col-lg-2">
                      <label for="filter" class="col-form-label">From</label>
                      <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="col-md-6 col-lg-2">
                      <label for="filter" class="col-form-label">To</label>
                      <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                  <div class="col-md-4 col-lg-4">
                    <label for="filter" class="col-form-label">Accounts</label>
                    <multiselect 
                      v-model="filterAccounts" 
                      placeholder="Select" 
                      label="account" 
                      track-by="accountMappingId" 
                      :options="accountList" 
                      :multiple="true" 
                      :limit="4"  ></multiselect>
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <label for="filter" class="col-form-label">Cusips</label>
                    <multiselect 
                      v-model="filterCusips" 
                      placeholder="Select" 
                      :options="cusipList" 
                      :multiple="true" 
                     
                      :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <label for="filter" class="col-form-label">Source</label>
                    <multiselect 
                      v-model="filterSource" 
                      placeholder="Select" 
                      :options="sourceoption" 
                      :multiple="false" 
                     
                      :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-4 col-lg-2">
                    <div class="form-check mt-5">
                        <input id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="isEmailSent" >
                        <label for="checkbox2" class="form-check-label">Email Sent</label>
                    </div>
                  </div>
                  <div class="col-md-12 text-center">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded">Clear</button>
                    <button @click="searchOffer()" type="button" class="btn btn-primary rounded">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
            <div class="row xsOnly">
                <div class="col-xl-12">
                <div class="card scrollbar vh-75" id="scroll">
                    <div class="table-responsive">                    
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                        <thead class="thead-light psticky">
                        <tr  >
                              <th 
                          scope="col" 
                          class="sort"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                          @click="sort('cusip')">CUSIP/DESC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                          @click="sort('quantity')">QTY</th>
                          <th
                            scope="col"
                            class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                            @click="sort('quantity')">Fill/Rem
                            </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                          @click="sort('price')">PRICE</th>
                          <!-- <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerValidity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerValidity'  ? 'sort-desc' : '']"  
                          @click="sort('offerValidity')">OFFER <br> VALIDITY</th> -->
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerType'  ? 'sort-desc' : '']"  
                          @click="sort('offerType')">OFFER <br>  TYPE</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                          @click="sort('coupon')">COUPON</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                          @click="sort('cost')">COST</th>
                          <th
                          scope="col"
                          class="sort text-left">TMC<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">TWR<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">KBP<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">MKTX<br>Status/Price
                          </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                          @click="sort('yield')">YIELD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                          @click="sort('yieldSpread')">SPREAD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'balance'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'balance'  ? 'sort-desc' : '']"  
                          @click="sort('balance')">BAL/MIN/INC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'successEcn'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'successEcn'  ? 'sort-desc' : '']"  
                          @click="sort('successEcn')">EXECUTED ECN</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedQuantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedQuantity'  ? 'sort-desc' : '']"  
                          @click="sort('executedQuantity')">EXECUTED QTY</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedPrice'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedPrice'  ? 'sort-desc' : '']"  
                          @click="sort('executedPrice')">EXECUTED PRICE</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedInterest'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedInterest'  ? 'sort-desc' : '']"  
                          @click="sort('executedInterest')">INTEREST</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedAt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedAt'  ? 'sort-desc' : '']"  
                          @click="sort('executedAt')">EXECUTED TIME</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ticketSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'ticketSpread'  ? 'sort-desc' : '']"  
                          @click="sort('ticketSpread')">TICKET SPREAD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'createSource'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'createSource'  ? 'sort-desc' : '']"  
                          @click="sort('createSource')">SOURCE</th>
                          <th scope="col" class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody class="list">
                        <tr v-if="totalRows == 0 && !loading">
                            <td><p class="nodata">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="offer in offerings" :key="offer.id" @click="getOfferDetails(offer)" v-bind:class="{'active-row': offer.isActive , 'trader-fill' : offer.status == 'TRADER_FILL'}">
                            <td>
                              <span class="cusips"> {{offer.cusipVal}}</span>
                              <span class="desc">{{offer.cusipDescription}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.quantity}}</span><br>
                          </td>
                           <td class="text-center">
                              <span class="mr-3 d-inline-block">Fill<br><span class="text-danger d-block">{{offer.executedQuantity || 0}}</span></span>
                              <span class="d-inline-block">REM<br><span class="text-success d-block">{{(offer.quantity - offer.executedQuantity) || 0}}</span></span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.price | currency }}   </span><br>
                          </td>
                          <!-- <td class="text-center">
                              <span>{{offer.offerValidity}}</span><br>
                          </td> -->
                          <td class="text-center">
                              <span>{{offer.offerType}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.coupon |  percent(3)}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.cost | currency}}</span><br>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:class="getEcnStatus(offer.tmcStatus).className">{{getEcnStatus(offer.tmcStatus).status}}</span>
                              <span class="text-primary">{{offer.tmcprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:class="getEcnStatus(offer.twdStatus).className">{{getEcnStatus(offer.twdStatus).status}}</span>
                              <span class="text-primary">{{offer.twdprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:class="getEcnStatus(offer.ibpStatus).className">{{getEcnStatus(offer.ibpStatus).status}}</span>
                              <span class="text-primary">{{offer.ibpprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.mktxStatus).message"  v-bind:class="getEcnStatus(offer.mktxStatus).className">{{offer.mktxStatus}}</span>
                              <span class="text-primary">{{offer.mktxPrice | currency}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.executedYield ? offer.executedYield + '%' : 'N/A'}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{(offer.executedPrice - offer.cost).toFixed(2)}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.balance}} - {{offer.minimum}} - {{offer.incrementVal}}</span>
                          </td>
                          <td class="text-center"><span>{{offer.successEcn}}</span></td>
                          <td class="text-center"><span>{{offer.executedQuantity}}</span></td>
                          <td class="text-center"><span>{{offer.executedPrice | currency}}</span></td>
                          <td class="text-center"><span>{{offer.executedInterest | currency}}</span></td>
                          <td class="text-center">{{offer.executedAt}}</td>
                          <td class="text-center">{{offer.ticketSpread}}</td>
                          <td class="text-center">{{offer.offerSource.toString()}}</td>
                          <td class="text-center">
                            <div class="d-inline-flex"> 
                                <button @click="openCustomerDetailsModal(offer)" class="btn ibtn btn-outline-primary" title="Holdings"><i class="far fa-user"></i></button>
                                <div class="dropdown">
                                  <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <i class="fas fa-ellipsis-v"></i>
                                  </button>
                                  <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                      <button type="button" v-if="offer.status == 'SUCCESS'" @click="emailOffer(offer)" class="dropdown-item" title="Email"><span class="far fa-envelope mr-1"></span> Email ticket</button>
                                      <button type="button" v-if="offer.status == 'SUCCESS'" @click="downloadOffer(offer)" class="dropdown-item" title="Download"><span class="fas fa-download mr-1"></span> Download ticket</button>
                                      <button type="button" v-if="offer.status == 'SUCCESS'" @click="printOffer(offer)" class="dropdown-item" title="Print"><span class="fas fa-print mr-1"></span> Print ticket</button>
                                      <button type="button" @click="deleteOffer(offer)"  class="dropdown-item del"><span class="fas fa-trash mr-1"></span> Delete</button>
                                      <button type="button" v-if="offer.status == 'SUCCESS' && !offer.isEmailSent" @click="selectedHolding = offer,toggleTicketModalOpen()" class="dropdown-item" title="update"><span class="fas fa-check mr-1"></span> Update Ticket Spread</button>

                                  </div>
                              </div>
                            </div>  
                          </td>
                        </tr>
                        </tbody>
                    </table> 
                    <!-- Pagination-->
                    <b-pagination
                        class="mt-4"
                        :total-rows="totalRows"
                        v-model="currentPage"
                        :per-page="perPage"
                        @input="getOfferList(currentPage)"
                    ></b-pagination>
                    <div class="total-records">
                        <span>Total Records : {{totalRows}}</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>  
      <customer-details 
        v-if="customerDetailModalOpen" 
        v-bind:offerData="selectedOffer" 
        v-bind:executedQty="selectedOffer.executedQuantity"
        v-bind:isTraderFill="isTraderFill" 
        @close="closeDetailsPopup()" />
      <add-offer
        v-bind:mode="'TRADE'"  
        v-if="addNewOfferModalOpen" 
        @close="closeAddOfferModal()">
        </add-offer>
      <TicketSpread v-bind:holding="selectedHolding" v-bind:moduleName="'IMS'" v-if="ticketModalOpen" @close="toggleTicketModalOpen()" />

    </div> 
      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import customerDetails from "../ims-offering/ImsOfferingCutomerDetails"
import Datepicker from 'vuejs-datepicker';
import addOffer from "../ims-offering/ImsAddOfferModal"
import TicketSpread from "@/components/common/UpdateTicketSpreadModal"


export default {
  name: "imsOfferRejectedListComponent",
  components : {
     customerDetails,
     Datepicker,
     addOffer,
     TicketSpread
  },
  data() {
    return {
        accessToken: null,
        config: config,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        selectedCusip : "",
        sortColumn: "latestDate",
        sortOrder: "DESC",
        stateConstants: stateConstants,
        offerings:[],
        customerDetailModalOpen : false,
        selectedOffer : {},
        fromDate : "",
        toDate : "",
        showFilters : false,
        filterAccounts : [],
        filterCusips : [],
        accountList: [],
        cusipList : [],
        isTraderFill : false,
        addNewOfferModalOpen : false,
        isEmailSent : false,
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        ticketModalOpen : false,
        selectedHolding : null,
        filterSource : null,
        sourceoption : [ 'IMS','ARBS',"AUTOBIDDER","ARBS FEED"]
    };
  },
  methods: {
     toggleTicketModalOpen(){
        this.ticketModalOpen = !this.ticketModalOpen;
        if(!this.ticketModalOpen){
          this.getOfferList(); 
        }
      },
      printOffer(offer){
        let routeData = this.$router.resolve({
          name: "printticket",
          query: {
            id: offer.id,
            isInventory : offer.isInventory
          }
        });
        window.open(routeData.href, "_blank");
      },
      emailOffer(offer){
        var message = null;
        if(offer.isEmailSent){
          message = "Email already sent, are you sure want to send it again?";
        }else{
          message = "Are you sure you want to email this trade?";
        }
        this.$confirm(message,"Email","question",{confirmButtonText:"SEND",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .get(config.baseUrlBidSide + "/excel/send-email?offerId="+offer.id,auth)
            .then(() => {
              this.loading = false;
              this.$alert("Email sent successfully","","success")              
            })
            .catch(() => {
                this.loading = false;              
            });
        });

      },
      downloadOffer(offer){
        var message = "Are you sure you want to download this trade?";
        this.$confirm(message,"Download","question",{confirmButtonText:"DOWNLOAD",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .get(config.baseUrlBidSide + "/excel/download?offerId="+offer.id,auth)
            .then((response) => {
              this.loading = false;
              //console.log("file",response.data)
              response.data.urls.forEach(file => {
                window.open(file, "_blank");
              })   
            })
            .catch(() => {
                this.loading = false;              
            });
        });

      },
      deleteOffer(offer){
      var message = "Are you sure you want to delete this trade?";
      this.$confirm(message,"","question",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "id":offer.id,
                  "status":"DELETED",
                  "updateByCognitoSub" : authService.getUser().cognitoSub
              }
          this.$http
          .put(config.baseUrlBidSide + "/offer/status",data,auth)
          .then(() => {
            this.loading = false;              
            this.getOfferList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
      closeDetailsPopup(){
        this.getOfferList()
        this.customerDetailModalOpen = false
      },
      closeAddOfferModal(){
        this.getOfferList();
        this.addNewOfferModalOpen = false
      },
      openAddOfferModal(){
        this.addNewOfferModalOpen = true;
      },
     getEcnStatus(ecnStatus){
      // if(ecnStatus == 'NEW'){
      //   return  { className : "border-success text-success",status : "NEW" }
      // }
      // if(ecnStatus == 'CREATED'){
      //   return  { className : "border-success text-success",status : "CREATED" }
      // }
      // if(ecnStatus == 'SUCCESS'){
      //   return  { className : "border-success text-success",status : "ACCEPTED" }
      // }
      return  { className : "border-success text-success",status : ecnStatus ? ecnStatus : 'N/A' }
    },
    openCustomerDetailsModal(offer){
       this.selectedOffer = offer;
       if(offer.status == 'TRADER_FILL'){
         this.isTraderFill = true;
       }else{
         this.isTraderFill = false;
       }
       this.customerDetailModalOpen = true;   
    },
    searchOffer(){
      this.getOfferList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getOfferList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getOfferList();
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getOfferDetails(offerSelected){
      this.offerings.forEach(function(offer) {
        offer.isActive = false;
      });
      offerSelected.isActive = true;
    },
    getOfferList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
      var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
      let cognitoSub = this.isTrader && !this.isAdmin && !this.isEditor ? authService.getUser().cognitoSub : "";
      // console.log(this.fromDate)
      // console.log(fDate)
      let createSource  = "&createSource=self,import,arbs_ibp,arbs_tmc,arbs_twd,autobidder_ibp,autobidder_tmc,autobidder_twd,ARBS_FEED_IBP,ARBS_FEED_TMC,ARBS_FEED_TWD,ARBS_FEED_MKTX";
      if(this.filterSource == "IMS"){
         createSource  = "&createSource=self,import"
      }
      if(this.filterSource == "ARBS"){
         createSource  = "&createSource=arbs_ibp,arbs_tmc,arbs_twd"
      }
      if(this.filterSource == "AUTOBIDDER"){
         createSource  = "&createSource=autobidder_ibp,autobidder_tmc,autobidder_twd"
      }
      if(this.filterSource == "ARBS FEED"){
         createSource  = "&createSource=ARBS_FEED_IBP,ARBS_FEED_TMC,ARBS_FEED_TWD,ARBS_FEED_MKTX"
      }
      
      this.$http
        .get(
          config.baseUrlBidSide +
            "/offer/listall?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=SUCCESS,TRADER_FILL"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate+
            "&showInvIndicator=true"+
            "&cusips="+
            this.filterCusips.toString()+
            "&accountMappingIds="+
            this.filterAccounts.map((e) => {return e.accountMappingId}).toString()+
            "&isEmailSent="+
            this.isEmailSent+
            "&cognitoSub=" +
            cognitoSub+
            createSource,
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(offer) {
           offer.createSource = offer.createSource.toLowerCase().includes('arbs') ? offer.createSource.replace("_"," ").toUpperCase() : "IMS";
          });
           this.offerings = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    getAllAccountList(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
        config.baseUrlBidSide +
            "/inventory/account-map-list",
            auth
        )
        .then(result => {
          this.accountList = result.data;
        })
    }, 
    getTradeCusipList(){
       const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
        config.baseUrlBidSide +
            "/offer/cusip-list?status=SUCCESS",
            auth
        )
        .then(result => {
          this.cusipList = result.data;
        })

    }
  },
  mounted() {
      this.fromDate = this.moment().format("MM-DD-YYYY");
      this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
      //this.getOfferList();
      this.getAllAccountList();
      this.getTradeCusipList();
      this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
          this.getOfferList();

        }
      });


  }
};
</script>
<style>
.trader-fill{
  background-color: #ffd7d7
}

</style>